// extracted by mini-css-extract-plugin
export var dark = "v_s0";
export var darkcookie = "v_s1";
export var tintedcookie = "v_s2";
export var regularcookie = "v_s3";
export var darkbase = "v_s4";
export var tintedbase = "v_s5";
export var regularbase = "v_s6";
export var darkraw = "v_s7";
export var tintedraw = "v_s8";
export var regularraw = "v_s9";
export var darkchick = "v_tb";
export var tintedchick = "v_tc";
export var regularchick = "v_td";
export var darkherbarium = "v_tf";
export var tintedherbarium = "v_tg";
export var regularherbarium = "v_th";
export var darkholiday = "v_tj";
export var tintedholiday = "v_tk";
export var regularholiday = "v_tl";
export var darkoffline = "v_tm";
export var tintedoffline = "v_tn";
export var regularoffline = "v_tp";
export var darkorchid = "v_tq";
export var tintedorchid = "v_tr";
export var regularorchid = "v_ts";
export var darkpro = "v_tt";
export var tintedpro = "v_tv";
export var regularpro = "v_tw";
export var darkrose = "v_tx";
export var tintedrose = "v_ty";
export var regularrose = "v_tz";
export var darktimes = "v_tB";
export var tintedtimes = "v_tC";
export var regulartimes = "v_tD";
export var darkwagon = "v_tF";
export var tintedwagon = "v_tG";
export var regularwagon = "v_tH";